import {
  ResetTacticContextFilter,
  SetAuthoringDefaultState,
  SetDisplayReferencesOnDocumentLevel,
  SetExpandedFilters,
  SetFootnotes,
  SetIsAuthoringStarted,
  SetProductAndCountryFilter,
  SetSelectedValues,
  SetTacticContextFilter,
} from '~/constants/actions';
import {
  GetAuthoringStarted,
  GetDisplayReferencesOnDocumentLevel,
  GetExpandedFilters,
  GetFootnotes,
  GetProductAndCountryFilter,
  GetSelectedValues,
  GetTacticContextFilters,
} from '~/constants/getters';

const defaultState = () => {
  return {
    isAuthoringStarted: false,
    expandedFilters: true,
    tacticContextsFilter: {},
    productAndCountryFilter: {},
    selectedValues: { collection: null, design: null },
    footnotes: [],
    displayReferencesOnDocumentLevel: false,
  };
};

const state = defaultState();

const mutations = {
  [SetIsAuthoringStarted](state, data) {
    state.isAuthoringStarted = data;
  },
  [SetExpandedFilters](state, data) {
    state.expandedFilters = data;
  },
  [SetAuthoringDefaultState](state) {
    Object.assign(state, defaultState());
  },
  [SetTacticContextFilter](state, { contextTypeId, tacticContext }) {
    if (
      state.tacticContextsFilter[contextTypeId] &&
      state.tacticContextsFilter[contextTypeId].id === tacticContext.id
    ) {
      delete state.tacticContextsFilter[contextTypeId];
    } else {
      state.tacticContextsFilter[contextTypeId] = tacticContext;
    }
  },
  [SetProductAndCountryFilter](state, data) {
    state.productAndCountryFilter = data;
  },
  [SetSelectedValues](state, { id, value }) {
    state.selectedValues[id] = value;
  },
  [ResetTacticContextFilter](state) {
    state.tacticContextsFilter = {};
  },
  [SetFootnotes](state, footnotes) {
    state.footnotes = footnotes;
  },
  [SetDisplayReferencesOnDocumentLevel](state, value) {
    state.displayReferencesOnDocumentLevel = value;
  },
};

const getters = {
  [GetAuthoringStarted](state) {
    return state.isAuthoringStarted;
  },
  [GetExpandedFilters](state) {
    return state.expandedFilters;
  },
  [GetTacticContextFilters](state) {
    return state.tacticContextsFilter;
  },
  [GetProductAndCountryFilter](state) {
    return state.productAndCountryFilter;
  },
  [GetSelectedValues](state) {
    return state.selectedValues;
  },
  [GetFootnotes](state) {
    return state.footnotes;
  },
  [GetDisplayReferencesOnDocumentLevel](state) {
    return state.displayReferencesOnDocumentLevel;
  },
};

const actions = {
  [SetIsAuthoringStarted]: ({ commit }, data) => {
    commit(SetIsAuthoringStarted, data);
  },
  [SetExpandedFilters]: ({ commit }, data) => {
    commit(SetExpandedFilters, data);
  },
  [SetAuthoringDefaultState]: ({ commit }) => {
    commit(SetAuthoringDefaultState);
  },
  [SetTacticContextFilter]: ({ commit }, data) => {
    commit(SetTacticContextFilter, data);
  },
  [ResetTacticContextFilter]: ({ commit }, data) => {
    commit(ResetTacticContextFilter, data);
  },
  [SetProductAndCountryFilter]: ({ commit }, data) => {
    commit(SetProductAndCountryFilter, data);
  },
  [SetSelectedValues]: ({ commit }, data) => {
    commit(SetSelectedValues, data);
  },
  [SetFootnotes]: ({ commit }, footnotes) => {
    commit(SetFootnotes, footnotes);
  },
  [SetDisplayReferencesOnDocumentLevel]: ({ commit }, value) => {
    commit(SetDisplayReferencesOnDocumentLevel, value);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
